"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M7.96875 2.44922L2.32031 18H0.0117188L6.51562 0.9375H8.00391L7.96875 2.44922ZM12.7031 18L7.04297 2.44922L7.00781 0.9375H8.49609L15.0234 18H12.7031ZM12.4102 11.6836V13.5352H2.82422V11.6836H12.4102Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;